import {BaseModel} from './base-model';

export class SuperObjectRelation extends BaseModel {
  meta_type = 'sub_model';
  context_id: string;
}
